export default __webpack_public_path__ + "static/media/back_lines1.bec7a1f4.png";